import {
  Component,
  OnChanges,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_frozen from "@amcharts/amcharts4/themes/frozen";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexDataLabels,
  ApexPlotOptions,
  ApexFill,
  ApexStroke,
  ApexLegend,
  ApexTitleSubtitle,
  ApexResponsive,
  ApexTheme,
  ApexGrid,
  ApexTooltip,
} from "src/app/shared/components/chart/apex-options";
import { AppsService } from "src/app/shared/services/apps.service";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import { differenceInCalendarDays } from "date-fns";
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";
export type chartOptionstwo = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  fill: ApexFill;
  responsive: ApexResponsive[];
  labels: any;
  stroke: ApexStroke;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  theme: ApexTheme;
  colors: any;
  grid: ApexGrid;
};

export type multiChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  markers: any; //ApexMarkers;
  stroke: any; //ApexStroke;
  yaxis: ApexYAxis | ApexYAxis[];
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  legend: ApexLegend;
  fill: ApexFill;
  tooltip: ApexTooltip;
};

am4core.useTheme(am4themes_frozen);
am4core.useTheme(am4themes_animated);
import * as L from "leaflet";

@Component({
  selector: "app-apsfl-oms-district-dashboard",
  templateUrl: "./apsfl-oms-district-dashboard.component.html",
  styleUrls: ["./apsfl-oms-district-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ApsflOmsDistrictDashboardComponent implements OnInit, OnChanges {
  /** Restored from <dxo-summary>, dropped by the bulk conversion. */
  gridGroups0: any[] = [
    { column: "cstmr_efctd_ct", summaryType: "sum" },
    { column: "asgn_emps", summaryType: "sum" },
    {
      column: "cstmr_efctd_ct",
      summaryType: "sum",
      displayFormat: "SumINRFormater",
    },
    {
      column: "asgn_emps",
      summaryType: "sum",
      displayFormat: "SumINRFormater",
    },
    { column: "emp_ct", summaryType: "sum", displayFormat: "SumINRFormater" },
    { column: "ttl_wrks", summaryType: "sum", displayFormat: "SumINRFormater" },
  ];
  /** Restored from <dxo-summary>, dropped by the bulk conversion. */
  gridTotals0: any[] = [
    {
      column: "cstmr_efctd_ct",
      summaryType: "sum",
      displayFormat: "SumINRFormater",
    },
    { column: "no_trps", summaryType: "sum", displayFormat: "SumINRFormater" },
    {
      column: "asgn_emps",
      summaryType: "sum",
      displayFormat: "SumINRFormater",
    },
    {
      column: "wrk_incld_expns",
      summaryType: "sum",
      displayFormat: "SumINRFormater",
    },
    {
      column: "amt",
      summaryType: "sum",
      displayFormat: "sumcurrencyINRFormater",
    },
    { column: "ttl", summaryType: "sum", displayFormat: "SumINRFormater" },
    { column: "inprg", summaryType: "sum", displayFormat: "SumINRFormater" },
    { column: "cmpltd", summaryType: "sum", displayFormat: "SumINRFormater" },
    { column: "ttl_wrks", summaryType: "sum", displayFormat: "SumINRFormater" },
    { column: "emp_ct", summaryType: "sum", displayFormat: "SumINRFormater" },
  ];

  /** Stable bound reference for <app-data-grid [cellPrepared]>. */
  bound_onCellPrepared = (e: any) => this.onCellPrepared(e);

  public chartOptionstwo: Partial<chartOptionstwo>;
  public chartOptionsThree: Partial<chartOptionstwo>;
  public multiChartOptions: Partial<multiChartOptions>;
  columnDefs: any;
  tb_id = "";
  slctd_dstrt = null;
  dbrd_lvl: any;
  tnt_id: any;
  WorksCrdData: any;
  tripCrdData: any;
  expnsCrdData: any;
  emplyCrdData: any;
  chartOptionsFour: {
    series: { name: string; data: number[] }[];
    chart: { type: string; height: number; stacked: boolean };
    plotOptions: { bar: { horizontal: boolean } };
    xaxis: { categories: number[]; title: { text: string } };
    yaxis: { title: { text: string } };
    fill: { opacity: number };
    legend: { position: string; horizontalAlign: string; offsetX: number };
    dataLabels: { enabled: boolean };
    colors: string[];
    title: { text: string };
  };
  heatMapDtls: any[];
  heatData: any[];
  shrdKy = [];
  chartOptionsFive: {
    series: { name: string; data: any[] }[];
    chart: { type: string; height: number; stacked: boolean };
    plotOptions: { bar: { horizontal: boolean; columnWidth: string } };
    grid: { borderColor: string };
    xaxis: { categories: any[]; title: { text: string } };
    yaxis: { title: { text: string } };
    fill: { opacity: number };
    legend: { position: string; horizontalAlign: string; offsetX: number };
    dataLabels: { enabled: boolean };
    // colors: ['#5967af', '#fd8900', '#34c38f'],
    colors: string[];
    title: { text: string };
  };
  dstrtdata: any;
  sidenav: boolean;
  param_dstrt_id: any;
  dstrt_nm: any;
  header_label = {
    name: `OMS  District Dashboard  `,
    dtepkrlbl: false,
  };
  EmployData;
  tb_nm: any;
  slctCrd_nm: any;
  slctCrd_clr: any;
  slctdCrd: any;
  AsstGrapData: any;
  expenseCtgry = [];
  selectdCtgry = 0;
  isGrouped = false;
  drwerTitle: string;
  appCond: number;
  columnVhcleDefs: (
    | { headerName: string; field: string; alignment: string; width: number }
    | { headerName: string; field: string; width: string; alignment: string }
    | {
        headerName: string;
        field: string;
        alignment: string;
        width?: undefined;
      }
  )[];
  vehicleData: any;
  selectedVehicle: any;

  userDtls;
  dstdbrdMap;
  _stBndPlgn;
  stPlygn;
  ap_map_bounds;
  inPrgWrks: any;
  wrkIcon: any;
  wrkLctnArry: any = [];
  _wrkLctnLyr;
  wrkData;
  selectdAsstCtgry = 0;
  AsstCtgry: any;
  clntDtls;
  tntLst: any = [];
  wrkStsLst = [];
  wrkGrpLst = [];
  wrk_grp_id = 0;
  oms_wrk_sts_id = 0;
  today = new Date();
  dateFormat = "dd/MM/yyyy";
  frmDt = moment(this.today).subtract(7, "days").toISOString(); // Subtract 7 days
  toDt = new Date();
  frmDate = moment(this.today).subtract(7, "days").format("YYYY-MM-DD");
  toDate = moment(this.today).format("YYYY-MM-DD");
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };
  visible: boolean = false;
  dateRnge: Date[] = [];
  slctd_trp: any;
  dwrWdth = 1200;
  constructor(
    public apiServ: AppsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.param_dstrt_id = params.dstrt_id;
      this.slctCrd_clr = params.crd_clr;
      this.slctCrd_nm = params.crd_nm;
      this.dateRnge = [params.from_dt, params.to_dt];
      this.slctdCrd = {
        crd_hdr: this.slctCrd_nm,
        clr_cd: this.slctCrd_clr,
        slct_dt_in: params.slct_dt_in,
      };
      // console.log(this.slctCrd_clr, this.slctCrd_nm)
    });
    this.userDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tnt_id = this.param_dstrt_id;
    this.userDtls[0].tnts.forEach((t) => {
      if (t.tnt_id == this.tnt_id) {
        // console.log(t)
        this.userDtls[0].lat = t.lat;
        this.userDtls[0].lng = t.lng;
      }
    });
  }
  lvl_id = null;
  gridData = [];
  columnDefs1;
  columnDefs2;
  columnDefs3;
  tabs = [
    { tb_nm: "Activities", tb_id: "1" },
    { tb_nm: "Trips", tb_id: "2" },
    { tb_nm: "Expenses", tb_id: "3" },
  ];

  dataSource1 = [];

  dataSource2 = [];
  dataSource3 = [];

  formatter1 = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });
  formatter2 = new Intl.NumberFormat("en-IN", {
    // style: "currency",
    currency: "INR",
  });
  mapData;
  columnEmplyDefs;
  dateRange: Date[] = [];
  ngOnInit() {
    const today = moment(this.today).toDate();
    const lastWeek = moment().subtract(7, "days").toDate();
    // this.dateRnge = [lastWeek, today];
    this.dateRange = [lastWeek, today];

    // console.log(this.param_dstrt_id)

    this.slctd_dstrt = parseInt(this.param_dstrt_id, 10);
    this.getDstrtData();
    this.lvl_id = 2;
    this.getGridData();
    setTimeout(() => {
      // this.last7dayaData()
      this.dstrtdata.forEach((e) => {
        if (e.tnt_id == this.slctd_dstrt) {
          this.dstrt_nm = e.tnt_nm;
        }
      });
      this.header_label = {
        name: `OMS ${this.dstrt_nm} District Dashboard  `,
        dtepkrlbl: false,
      };
    }, 1000);

    this.columnDefs1 = [
      { headerName: "S.No", field: "sno", alignment: "center", width: 60 },
      {
        headerName: "Mandal ",
        field: "mndl",
        width: "auto",
        alignment: "left",
      },
      {
        headerName: "Work Description ",
        field: "oms_wrm_dsc_tx",
        width: "auto",
        alignment: "left",
      },
      {
        headerName: "Work Type",
        field: "wrk_typ_nm",
        alignment: "left",
        groupIndex: 2,
      },
      { headerName: "Work Group", field: "wrk_grp_nm", alignment: "left" },
      { headerName: "Issue Type", field: "isue_typ_nm", alignment: "left" },
      { headerName: "Work Status", field: "wrk_sts_nm", alignment: "left" },
      {
        headerName: "No of Customers Effected",
        field: "cstmr_efctd_ct",
        alignment: "center",
      },
      {
        headerName: "No of Employees Assigned",
        field: "cstmr_efctd_ct",
        alignment: "center",
      },
    ];
    this.columnDefs = this.columnDefs1;
    // this.columnDefs2 = [
    //   { headerName: 'S.No', field: 'sno', alignment: 'center', width: 60 },
    //   { headerName: 'Category ', field: 'ctgry_nm', width: 'auto', alignment: 'left', },
    //   { headerName: 'Month ', field: 'mnth', width: 'auto', alignment: 'left', visible: this.lvl_id == 3 ? true : false },
    //   { headerName: 'Total Trips', field: 'ttl', alignment: 'center' },
    //   { headerName: 'Inprogress', field: 'inprg', alignment: 'center' },
    //   { headerName: 'Completed', field: 'cmpltd', alignment: 'center' },
    //   { headerName: 'Distance Travel', field: 'dtnc_trvl', alignment: 'center' },
    // ]
    // this.columnDefs3 = [
    //   { headerName: 'S.No', field: 'sno', alignment: 'center', width: 60 },

    //   { headerName: 'Category ', field: 'ctgry_nm', width: 'auto', alignment: 'left', },
    //   { headerName: 'Month ', field: 'mnth', width: 'auto', alignment: 'left', visible: this.lvl_id == 3 ? true : false },
    //   { headerName: 'Work Include Expenses', field: 'wrk_incld_expns', alignment: 'center' },
    //   { headerName: 'Amount', field: 'amt', alignment: 'center' },

    // ]

    setTimeout(() => {
      this.selctedCatrd(this.slctdCrd);
      this.ngOnChanges();
    }, 1000);

    this.getDistEmplay();
    this.getvehiclsData();
    this.chartOptionsFour = {
      series: [
        {
          name: "Total",
          data: [
            44, 55, 41, 67, 22, 43, 21, 44, 55, 41, 67, 22, 43, 21, 22, 43, 21,
          ],
        },
        {
          name: "In progress",
          data: [
            13, 23, 20, 8, 13, 27, 33, 13, 23, 20, 8, 13, 27, 33, 22, 43, 21,
          ],
        },
        {
          name: "completed",
          data: [
            11, 17, 15, 15, 21, 14, 15, 11, 17, 15, 15, 21, 14, 15, 22, 43, 21,
          ],
        },
      ],
      chart: {
        type: "bar",
        height: 800,
        stacked: true,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          // columnWidth: '50%',
        },
      },

      xaxis: {
        categories: [
          29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 18, 17, 16, 15,
        ],
        title: {
          text: "Dates",
        },
      },
      yaxis: {
        title: {
          text: "Number of Trips",
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#008FFB", "#00E396", "#FEB019"],
      title: {
        text: "",
      },
    };

    this.getDrpdownMster();
    this.initializeMap();
    this.getInPrgrsWrks();
  }
  getDrpdownMster() {
    this.apiServ.get(`apsfl/app/wrkGrpLst`).subscribe((res) => {
      console.log(res);
      if (res["status"] == 200) {
        // console.log(res['data'])
        res["data"][4].forEach((e) => {
          if (e.vw_in == 1) {
            this.wrkStsLst.push(e);
          }
        });

        this.wrkGrpLst = res["data"][0];
        this.wrk_grp_id = 0;
        this.oms_wrk_sts_id = 0;
      }
    });
  }
  onChange(e): void {
    this.frmDt = e;
    this.frmDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
    this.toDate = moment(this.dateRange[1]).format("YYYY-MM-DD");
  }
  onDtChange(e): void {
    this.toDt = e;
    this.toDate = moment(this.toDt).format("YYYY-MM-DD");
  }
  initializeMap() {
    try {
      this.dstdbrdMap = L.map("dstdbrdMap", {
        center: [this.userDtls[0].lat, this.userDtls[0].lng],
        zoom: 9,
      });
      const tiles = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 22,
          minZoom: 3,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );
      tiles.addTo(this.dstdbrdMap);
    } catch (e) {}
    this.dstdbrdMap.setView([this.userDtls[0].lat, this.userDtls[0].lng], 10);
    this._wrkLctnLyr = L.layerGroup();

    this.getInPrgrsWrks();
  }
  // stateBounds() {
  //   this._stBndPlgn = L.layerGroup();
  //   let options = {
  //     color: 'none',
  //     fill: false
  //   }
  //   this.stPlygn = L.polygon([
  //     [19.0, 77.0],
  //     [19.0, 84.5],
  //     [12.5, 84.5],
  //     [12.5, 77.0]
  //   ], options).addTo(this._stBndPlgn);
  //   this._stBndPlgn.addTo(this.dstdbrdMap)
  //   this.dstdbrdMap.setView([this.stPlygn.getCenter().lat, this.stPlygn.getCenter().lng], 7);
  //   this.ap_map_bounds = this.stPlygn.getBounds();
  //   this.setBounds();

  // }
  // setBounds() {
  //   if (this.dstdbrdMap.getBounds().intersects(this.ap_map_bounds)) {
  //     return;
  //   } else {
  //     this.dstdbrdMap.fitBounds(this.ap_map_bounds);
  //   }
  // }
  getInPrgrsWrks() {
    var postData = {
      tnt_id: this.tnt_id,
      oms_wrk_sts_id: this.oms_wrk_sts_id,
      wrk_grp_id: this.wrk_grp_id,
      frm_dt: this.frmDate,
      to_dt: this.toDate,
    };
    this.apiServ
      .post(postData, `apsfl/dashboard/works/inprogrss`)
      .subscribe(async (res) => {
        if (res["status"] == 200) {
          this.inPrgWrks = res["data"];
          // console.log(this.inPrgWrks);
          await this.wrksPrgrswithPromisepool(this.inPrgWrks, 15);
        }
      });
  }
  async wrksPrgrswithPromisepool(inPrgWrks: any, batchSize: number) {
    console.log("in promiseeeeeeeeeeeeeee");
    let that = this;
    const markerPositions: any[] = []; // Array to hold marker positions
    const promiseProducer = (points: any) => {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          try {
            // console.log(points)
            if (points.w_lat != undefined && points.w_lng != undefined) {
              let icnStng = "";
              if (points.wrk_sts_id == 3) {
                icnStng = "Workll";
              } else if (points.wrk_sts_id == 6) {
                icnStng = "wrk_completed";
              } else {
                icnStng = "wrk_in_prg";
              }
              this.wrkIcon = new L.Icon({
                iconUrl:
                  "/assets/images/markers/mapIcons/m/" + icnStng + ".png",
                iconSize: [32, 35],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                shadowSize: [41, 41],
              });
              this.wrkLctnArry = L.marker([points.w_lat, points.w_lng], {
                icon: this.wrkIcon, // Custom icon
                // title: "Marker Title" // Tooltip title
                options: {
                  oms_wrk_id: points.oms_wrk_id,
                },
              })
                .addTo(this._wrkLctnLyr)
                .on("click", function (e) {
                  that.goToWorkProfile(e.target);
                });
              this._wrkLctnLyr.addTo(this.dstdbrdMap);
              markerPositions.push([points.w_lat, points.w_lng]);
              resolve();
            } else {
              resolve();
            }
            // }
          } catch (e) {
            // console.log(e)
          }
        }, 10); // Simulating a processing delay
      });
    };

    const numBatches = Math.ceil(inPrgWrks.length / batchSize);

    for (let i = 0; i < numBatches; i++) {
      const start = i * batchSize;
      const end = start + batchSize;
      const batch = inPrgWrks.slice(start, end);
      try {
        const batchPromises = batch.map((points) => promiseProducer(points));
        await Promise.all(batchPromises);
      } catch (e) {
        // console.log(e)
      }
    }

    // After all markers are added, fit the map view to the bounds of the markers
    if (markerPositions.length > 0) {
      const bounds = L.latLngBounds(markerPositions); // Create bounds from all marker positions
      this.dstdbrdMap.fitBounds(bounds); // Adjust map view to fit all markers
    }
  }
  goToWorkProfile(e) {
    // console.log(e)
    this.wrkData = e.options.options;
    this.visible = true;
  }
  ngOnChanges() {
    this.slctd_dstrt = this.slctd_dstrt;
    this.slctdCrd = this.slctdCrd;
    this.header_label = {
      name: `OMS ${this.dstrt_nm} District Dashboard  `,
      dtepkrlbl: false,
    };
  }

  getDstrtData() {
    this.apiServ.get(`apsfl/data/districts`).subscribe((res) => {
      if (res["status"] == 200) {
        this.dstrtdata = res["data"];
      }
    });
  }

  getDstrwiseData(e) {
    this.dstrtdata.forEach((e) => {
      if (e.tnt_id == this.slctd_dstrt) {
        this.dstrt_nm = e.tnt_nm;
      }
    });
    this.userDtls[0].tnts.forEach((t) => {
      if (t.tnt_id == this.tnt_id) {
        // console.log(t)
        this.userDtls[0].lat = t.lat;
        this.userDtls[0].lng = t.lng;
      }
    });
    this.dstdbrdMap.setView([this.userDtls[0].lat, this.userDtls[0].lng], 10);
    // console.log(this.dstrt_nm)
    this.ngOnChanges();
    this.getGridData();
    this.getDistEmplay();
  }

  selctedCatrd(e) {
    console.log(e);

    this.tb_nm = e.crd_hdr;

    var today = new Date();
    const date = new Date(2024, 9, 1);
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    if (e.slct_dt_in == 1) {
      this.dateRnge = [date, today];
    } else if (e.slct_dt_in == 2) {
      this.dateRnge = [firstDayOfMonth, today];
    } else if (e.slct_dt_in == 3) {
      this.dateRnge = [today, today];
    }
    setTimeout(() => {
      this.onChangeDate();
    }, 1000);

    if (e.crd_hdr == "WORKS") {
      console.log("111111111111111111111111");
      this.tb_id = "1";
      this.ChangeLevel(this.lvl_id);
    } else if (e.crd_hdr == "TRIPS") {
      console.log("2222222222222222222222222222222");
      this.tb_id = "2";
      this.ChangeLevel(this.lvl_id);
    } else if (e.crd_hdr == "EXPENSES") {
      console.log("3333333333333333333333333333333333");
      this.tb_id = "3";
      this.ChangeLevel(this.lvl_id);
    }
    // this.slctdCrd=e

    this.colorChanges(e.clr_cd);
  }

  colorChanges = (clr_cd) => {
    console.log("test case");
    document.documentElement.style.setProperty("--colorcode", clr_cd);
  };

  currencyINRFormater = (val: any) => {
    if (typeof val == "string") {
      return val;
    } else {
      return this.formatter1.format(parseInt(val, 10))
        ? this.formatter1.format(parseInt(val, 10))
        : 0;
    }
  };
  INRFormater = (val: any) => {
    if (typeof val == "string") {
      return val;
    } else {
      return this.formatter2.format(parseInt(val, 10))
        ? this.formatter2.format(parseInt(val, 10))
        : 0;
    }
  };

  SumINRFormater = (val: any) => {
    if (val) {
      if (val == "Total:") {
        return val;
      }
      return this.formatter2.format(parseInt(val, 10))
        ? this.formatter2.format(parseInt(val, 10))
        : 0;
    }
    return "";
  };

  sumcurrencyINRFormater = (val: any) => {
    if (val) {
      if (val == "Total:") {
        return val;
      }
      return this.formatter1.format(parseInt(val, 10))
        ? this.formatter1.format(parseInt(val, 10))
        : 0;
    }
    return "";
  };

  onCellPrepared(e) {
    // console.log(e)
    if (e.rowType === "header" || e.rowType === "group") {
      return;
    }
    if (e.column.dataField == "wrk_sts_nm" || e.column.dataField == "trp_sts") {
      if (e.data && e.value) {
        if (e.value == "In Progress") {
          e.cellElement.style.color = "#f19000";
          e.cellElement.style.cursor = `pointer`;
          e.cellElement.style.fontWeight = `500`;
        } else if (e.value == "Completed") {
          e.cellElement.style.color = "#4CAF50";
          e.cellElement.style.cursor = `pointer`;
          e.cellElement.style.fontWeight = `500`;
        }

        if (e.value == "In Trip") {
          e.cellElement.style.color = "#f19000";
          e.cellElement.style.cursor = `pointer`;
          e.cellElement.style.fontWeight = `500`;
        } else if (e.value == "Trip Completed") {
          e.cellElement.style.color = "#4CAF50";
          e.cellElement.style.cursor = `pointer`;
          e.cellElement.style.fontWeight = `500`;
        }
      }
    }
  }

  onCellClick(e) {
    if (e.rowType === "header" || e.rowType === "group") {
      return;
    }

    if (!this.slctd_dstrt && e.columnIndex != 1) {
      return;
    }
    console.log(e, "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    // this.slctd_dstrt = e.data.dstrt_id;
    var disrt_ws_ctgry = [];
    // this.category_data1.forEach(e => {
    //   if(e.dstrt_id==this.slctd_dstrt){
    //     disrt_ws_ctgry.push(e)
    //   }
    // });

    // this.columnDefs = this.columnDefs1
  }
  getDstrt_Wse_data() {}

  gotoTripTimeline(data) {
    this.slctd_trp = data.data.trp_rn_id;
    this.dwrWdth = 600;
    this.sidenav = true;
    this.appCond = 4;
    this.drwerTitle = data.data.asrt_nm;
  }

  getDistEmplay() {
    this.apiServ
      .get(`apsfl/districts/employee/${this.slctd_dstrt}`)
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.EmployData = res["data"];
          var count = 1;
          this.EmployData.forEach((e) => {
            e["sno"] = count++;
          });
        }
      });
  }

  // Detect grouping
  onContentReady(e) {
    const groupedColumns = e.component
      .getVisibleColumns()
      .filter((c) => c.groupIndex !== undefined);
    this.isGrouped = groupedColumns.length > 0;
  }

  async ChangeLevel(e) {
    this.lvl_id = e;

    this.columnDefs1 = [];
    this.columnDefs2 = [];
    this.columnDefs3 = [];
    console.log(this.dataSource1, this.dataSource2);
    if (this.tb_id == "1") {
      console.log("categoryyyyyyyyyyyyyyyyyyyyyy", "tab1");

      this.columnDefs1 = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 60,
          visible: false,
        },
        {
          headerName: "Mandal ",
          field: "mndl_nm",
          width: "auto",
          alignment: "left",
        },
        {
          headerName: "Work Description ",
          field: "oms_wrm_dsc_tx",
          width: "auto",
          alignment: "left",
        },
        {
          headerName: "Work type",
          field: "wrk_typ_nm",
          alignment: "left",
          groupIndex: 2,
        },
        { headerName: "Work Group", field: "wrk_grp_nm", alignment: "left" },
        { headerName: "Issue Type", field: "isue_typ_nm", alignment: "left" },
        { headerName: "Work Status", field: "wrk_sts_nm", alignment: "left" },
        {
          headerName: "No of Customers Effected",
          field: "cstmr_efctd_ct",
          alignment: "center",
        },
        {
          headerName: "No of Employees Assigned",
          field: "asgn_emps",
          alignment: "center",
        },
      ];

      this.columnEmplyDefs = [
        { headerName: "S.No", field: "sno", alignment: "center", width: 60 },
        {
          headerName: "Employee Name",
          field: "crw_nm",
          width: 300,
          alignment: "left",
        },
        {
          headerName: "Mobile Number ",
          field: "crw_ph",
          width: "auto",
          alignment: "center",
        },
        { headerName: "License", field: "crw_lcnse_nu", alignment: "left" },
        { headerName: "Date Of Joining", field: "DOJ", alignment: "center" },
        {
          headerName: "No of Works Assigned",
          field: "no_of_wrk_assigned",
          alignment: "center",
        },
      ];
      this.columnDefs = this.columnDefs1;
      this.gridData = this.dataSource1;
      this.EmployData = this.EmployData;

      console.log(this.gridData);
    } else if (this.tb_id == "2") {
      console.log("categoryyyyyyyyyyyyyyyyyyyyyy", "tab1");
      this.columnDefs2 = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 60,
          visible: false,
        },

        // { headerName: 'Work Type', field: 'wrk_typ_nm', width: 'auto', alignment: 'left' },
        // { headerName: 'No. of Vehicles', field: 'ttl', alignment: 'center' },
        // { headerName: 'Operated', field: 'ttl', alignment: 'center' },
        // { headerName: 'Not Operated', field: 'ttl', alignment: 'center' },
        // { headerName: 'Total Trips', field: 'ttl', alignment: 'center' },
        // { headerName: 'In Trips', field: 'inprg', alignment: 'center' },
        // { headerName: 'Completed', field: 'cmpltd', alignment: 'center' },
        // { headerName: 'Distance Travel', field: 'dtnc_trvl', alignment: 'center' },
        // { headerName: 'Mandal ', field: 'mndl_nm', width: 'auto', alignment: 'left' },
        // { headerName: 'Work Description ', field: 'oms_wrm_dsc_tx', width: 'auto', alignment: 'left' },
        {
          headerName: "Work type",
          field: "wrk_typ_nm",
          alignment: "left",
          groupIndex: 2,
        },
        { headerName: "Vehicle Number", field: "asrt_nm", alignment: "left" },
        { headerName: "Start Time", field: "strt_dt", alignment: "center" },
        { headerName: "End Time", field: "end_dt", alignment: "center" },
        { headerName: "Trip Status", field: "trp_sts", alignment: "left" },
        { headerName: "Total Works", field: "ttl_wrks", alignment: "Center" },
        {
          headerName: "No of Customers Effected",
          field: "cstmr_efctd_ct",
          alignment: "center",
        },
        {
          headerName: "No of Employees Assigned",
          field: "asgn_emps",
          alignment: "center",
        },
      ];

      this.columnVhcleDefs = [
        { headerName: "S.No", field: "sno", alignment: "center", width: 60 },
        {
          headerName: "Vehicle Name",
          field: "asrt_ctgry_nm",
          width: "auto",
          alignment: "left",
        },
        {
          headerName: "Vehicle Number",
          field: "asrt_nm",
          width: "auto",
          alignment: "left",
        },
        { headerName: "Group Name", field: "asrt_grp_nm", alignment: "center" },
        {
          headerName: "IMEI Number",
          field: "dev_imei_nu",
          alignment: "center",
        },
      ];
      this.columnDefs = this.columnDefs2;
      this.gridData = this.dataSource2;
      this.vehicleData = this.vehicleData;
      this.chartOptionsThree = this.chartOptionsThree;
    } else if (this.tb_id == "3") {
      console.log("categoryyyyyyyyyyyyyyyyyyyyyy", "tab1");
      this.columnDefs3 = [
        { headerName: "S.No", field: "sno", alignment: "center", width: 60 },
        {
          headerName: "Category ",
          field: "ctgry_nm",
          width: "auto",
          alignment: "left",
        },
        {
          headerName: "Work Include Expenses",
          field: "wrk_incld_expns",
          alignment: "center",
        },
        {
          headerName: "Total Amount",
          field: "amt",
          alignment: "center",
          format: this.currencyINRFormater,
        },
      ];
      this.columnDefs = this.columnDefs3;
      this.gridData = this.dataSource3;
      this.chartOptionsThree = this.chartOptionsThree;
    }
  }

  getvehiclsData() {
    this.vehicleData = [];
    this.apiServ
      .get(`apsfl/districts/data/vehicles/${this.slctd_dstrt}`)
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.vehicleData = res["data"];
          var count = 1;
          this.vehicleData.forEach((e) => {
            e["sno"] = count;
            count++;
          });
        }
      });
  }

  onChangeDate() {
    this.getGridData();
  }

  getGridData() {
    var postdata = {
      lvl_id: this.lvl_id,
      tb_id: this.tb_id,
      dstrt_id: this.slctd_dstrt,
      from_dt:
        this.lvl_id != 3 ? moment(this.dateRnge[0]).format("YYYY-MM-DD") : null,
      to_dt:
        this.lvl_id != 3 ? moment(this.dateRnge[1]).format("YYYY-MM-DD") : null,
    };
    this.dataSource1 = [];
    this.dataSource2 = [];
    this.dataSource3 = [];
    this.gridData = [];
    this.apiServ.post(postdata, `apsfl/district/data/grid`).subscribe((res) => {
      if (res["status"] == 200) {
        var data = res["data"];
        (this.dataSource1 = data[0]),
          (this.dataSource2 = data[1]),
          (this.dataSource3 = data[2]),
          console.log(this.dataSource1);
        var co1 = 1;
        var co2 = 1;
        var co3 = 1;
        this.dataSource1.forEach((e) => {
          e["sno"] = co1++;
        });
        this.dataSource2?.forEach((e) => {
          e["sno"] = co2++;
        });
        this.dataSource3?.forEach((e) => {
          e["sno"] = co3++;
        });
        this.ChangeLevel(this.lvl_id);
      }
    });
  }

  gotoProfile(data, cnd) {
    this.dwrWdth = 1200;
    console.log(data);
    this.sidenav = true;
    if (cnd == "work") {
      this.appCond = 1;
      // this.drwerTitle = 'Work Profile'
      this.drwerTitle =
        `${data.data?.wrk_typ_nm}` +
        " Work Starts On : " +
        data.data?.wrk_strt_dt;

      // wrkDtls[0]?.wrk_typ_nm}
    } else if (cnd == "employ") {
      this.appCond = 2;
      this.drwerTitle = ` ${data.data.crw_nm}`;
    } else if (cnd == "Vehicles") {
      this.selectedVehicle = data.data;
      this.appCond = 3;
      this.drwerTitle = "Vehicle Profile";
    }

    this.wrkData = data.data;
  }
  closeSideBar() {
    this.sidenav = false;
  }

  gotoDstrctDshbrd() {
    this.router.navigate(["/internal/dashboard/apsfloms"]);
  }

  focusedRowKey = 5;
  autoNavigateToFocusedRow = true;
  onFocusedRowChanging(e) {
    console.log(e);
    if (e) {
      const rowsCount = e.component.getVisibleRows().length;
      const pageCount = e.component.pageCount();
      const pageIndex = e.component.pageIndex();
      console.log("rowsCount", rowsCount);
      console.log("pageCount", pageCount);
      console.log("pageIndex", pageIndex);
    }
  }

  onFocusedRowChanged(e) {
    console.log(e);
  }
  // onExporting() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.
}
